<template>
  <ul class="navigation">
    <li v-for="link in navigationBarLinks" :key="link.url">
      <template v-if="hasChildLinks(link)">
        <Accordion class="navigation__dropdown" show-arrow>
          <template #header>{{ link.title }}</template>
          <template #body>
            <ul>
              <li class="u__hide--desktop">
                <a :href="link.url" class="navigation__child-link"
                  >Shop All {{ link.title }}</a
                >
              </li>
              <li v-for="childLink in link.items" :key="childLink.url">
                <a :href="childLink.url" class="navigation__child-link">{{
                  childLink.title
                }}</a>
              </li>
            </ul>
          </template>
        </Accordion>
      </template>
      <a v-else :href="link.url" class="navigation__link">
        {{ link.title }}
      </a>
    </li>
  </ul>
  <ul class="sub-navigation">
    <li>
      <a href="/account" class="sub-navigation__link">Account</a>
    </li>
    <li>
      <a href="/pages/members" class="sub-navigation__link">Members Only.</a>
    </li>
    <li>
      <a href="/pages/returns" class="sub-navigation__link">Returns</a>
    </li>
    <li>
      <a href="/pages/help" class="sub-navigation__link">Help</a>
    </li>
    <li>
      <a href="/pages/sustainability" class="sub-navigation__link">
        Sustainability
      </a>
    </li>
  </ul>
  <div class="divider"></div>
  <Currency
    :options="dropdownoptions"
    :selected="currencyCode"
    title="Currency"
    class="currency-dropdown"
    @changed="handleCurrencyChange"
  />
</template>

<script>
import Accordion from "@/components/Accordion.vue";
import DropDown from "@/components/DropDown.vue";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "Navigation",
  components: {
    Accordion,
    Currency: DropDown,
  },
  data() {
    return {
      dropdownoptions: [
        {
          value: "gbp",
          label: "GBP (£)",
        },
        {
          value: "eur",
          label: "EUR (€)",
        },
        {
          value: "usd",
          label: "USD ($)",
        },
        {
          value: "aud",
          label: "AUD ($)",
        },
      ],
    };
  },
  computed: {
    ...mapState("app", ["navigationBarLinks"]),
    ...mapGetters("app", ["currencyCode"]),
  },
  methods: {
    ...mapActions("app", ["changeCurrency"]),
    handleCurrencyChange(value) {
      this.changeCurrency(value);
    },
    hasChildLinks(link) {
      if (link.items.length > 0) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";
@import "@/assets/css/components/navigation";

.navigation {
  padding: 0 0 12px;
}

.divider {
  border: solid 0.5px #dddddd;
  margin: 20px;
}

.currency-dropdown {
  padding: 0 6px;
  box-shadow: none;

  ::v-deep(.dropdown__panel) {
    position: static;
    box-shadow: none;
  }
}
</style>
